import { normalizeSearch } from "../../../../components/collectionTools";
export const productPriceWithTax = (row) => {
  if (
    row.price == null ||
    row.price === "" ||
    !Number.isFinite(Number(row.price)) ||
    Number(row.price) < 0
  )
    return null;
  let tax = row.tax;
  if (typeof tax === "string") {
    try {
      tax = JSON.parse(tax);
    } catch {
      return null;
    }
  }
  const rate = typeof tax === "object" && tax !== null ? tax.value : tax;
  if (rate == null || rate === "" || !Number.isFinite(Number(rate)))
    return null;
  return Number((Number(row.price) * (1 + Number(rate) / 100)).toFixed(2));
};
export const productMoney = (value) =>
  value == null
    ? "—"
    : new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
      }).format(value);
export const productView = (
  rows,
  {
    tab = "all",
    search = "",
    status = "",
    category = "",
    catalog = "",
    sort = "name-asc",
  },
) => {
  const text = normalizeSearch(search.trim());
  const filtered = rows.filter(
    (row) =>
      (tab !== "draft" || row.status === "DRAFT") &&
      (tab !== "review" || row.missingFields?.length > 0) &&
      (!status || row.status === status) &&
      (!category || row.categoryIds?.includes(category)) &&
      (!catalog || row.catalogIds?.includes(catalog)) &&
      (!text ||
        normalizeSearch(`${row.name || ""} ${row.reference || ""}`).includes(
          text,
        )),
  );
  const direction = sort.endsWith("desc") ? -1 : 1;
  return filtered.sort((a, b) => {
    if (sort.startsWith("price")) {
      const av = productPriceWithTax(a),
        bv = productPriceWithTax(b);
      if (av == null && bv != null) return 1;
      if (bv == null && av != null) return -1;
      if (av !== bv) return (av - bv) * direction;
    }
    return (
      String(a.name || "").localeCompare(String(b.name || ""), "es", {
        numeric: true,
        sensitivity: "base",
      }) * direction || String(a.productId).localeCompare(String(b.productId))
    );
  });
};
